export const hyphenToCamelCase = (type) => {
  const camelCaseValue = type.replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });
  return camelCaseValue;
};

export function camelToPara(str) {
  if (!str) return '';
  let result = str[0].toUpperCase();
  for (let i = 1; i < str.length; i++) {
    if (str[i] === str[i].toUpperCase() && /[A-Z]/.test(str[i])) {
      result += ' ' + str[i];
    } else {
      result += str[i];
    }
  }
  return result;
}
